// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602101203/js/" + chunkId + "." + {"44":"477274f8","225":"1922de81","481":"43aa6b53","486":"db622f2a","770":"18feb092"}[chunkId] + ".0.8655147835568695.chunk.js";
};